import React, { useCallback } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import * as api from '@ubeya/shared/services/api';
import { ALLOWED_DOCUMENT_EXTENSIONS } from '@ubeya/shared/constants';
import useUser from '@ubeya/shared/hooks/auth/useUser';
import { smallSemiBold, FileUpload as BaseFileUpload, flexCenter } from '@ubeya/shared-web/components';
import useArrayManagement from '@ubeya/shared-web/hooks/useArrayManagement';
import { ReactComponent as PlusIcon } from '@ubeya/shared-web/assets/plus.svg';

const FileUpload = styled(BaseFileUpload)`
  margin-top: ${({ small }) => (small ? 0 : 17)}px;
  ${flexCenter}
  cursor: pointer;
  ${smallSemiBold};
  width: ${({ small }) => (small ? 30 : 100)}px;
  height: ${({ small }) => (small ? 30 : 100)}px;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.black};
  border: 1px dashed ${({ theme }) => theme.colors.grey2};
  text-align: center;
  outline: none;

  > svg {
    width: ${({ small }) => (small ? 13 : 20)}px;
    height: ${({ small }) => (small ? 13 : 20)}px;
  }

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};

    path {
      fill: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const AddDocument = ({ small }) => {
  const {
    data: { firstName, lastName }
  } = useUser();
  const { handleAddItems } = useArrayManagement('documents');

  const onUploaded = useCallback(
    (data) =>
      handleAddItems(
        data.map(({ file, path }) => ({
          title: file.name,
          path,
          date: moment(),
          by: `${firstName} ${lastName}`,
          file
        }))
      ),
    [firstName, handleAddItems, lastName]
  );

  return (
    <div>
      <FileUpload apiFunc={api.uploadImage} onUploaded={onUploaded} accept={ALLOWED_DOCUMENT_EXTENSIONS} small={small}>
        <PlusIcon />
      </FileUpload>
    </div>
  );
};

export default AddDocument;
